export default class SurveysWorkflowsIndex {

  constructor() {}

  render() {
    $(document).on('click', '.set-last-calendar-year', function () {
      const year = new Date().getFullYear() - 1;
      $('#survey_data_from').val(year + '-01-01');
      $('#survey_data_to').val(year + '-12-31');
    });

    $(document).on('click', '.set-this-calendar-year', function () {
      const year = new Date().getFullYear();
      $('#survey_data_from').val(year + '-01-01');
      $('#survey_data_to').val(year + '-12-31');
    });

    $(document).on('click', '.set-trailing-12-months', function () {
      const today = new Date();
      const from = new Date(today);
      from.setFullYear(from.getFullYear() - 1);
      from.setDate(from.getDate() + 1);
      $('#survey_data_from').val(from.toISOString().slice(0, 10));
      $('#survey_data_to').val(today.toISOString().slice(0, 10));
    });

    const submissionField = $('#survey_tracking_attributes_submission_deadline');
    const approvalField   = $('#survey_tracking_attributes_approval_deadline');

    const addWorkingDays = (dateStr, days) => {
      const d = new Date(dateStr + 'T00:00:00');
      let added = 0;
      while (added < days) {
        d.setDate(d.getDate() + 1);
        const dow = d.getDay();
        if (dow !== 0 && dow !== 6) added++;
      }
      const yyyy = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      const dd = String(d.getDate()).padStart(2, '0');
      return `${yyyy}-${mm}-${dd}`;
    };

    const syncApprovalDeadline = (submissionVal) => {
      if (submissionVal) {
        approvalField.val(addWorkingDays(submissionVal, 3));
      } else {
        approvalField.val('');
      }
    };

    // On page load: populate approval deadline if submission is set but approval is not
    if (submissionField.val() && !approvalField.val()) {
      syncApprovalDeadline(submissionField.val());
    }

    // On user change: default approval if blank, clear if submission cleared,
    // and update if new submission date is past the current approval deadline
    submissionField.on('change', function () {
      const val = $(this).val();
      const approvalVal = approvalField.val();
      if (!val || !approvalVal || val > approvalVal) {
        syncApprovalDeadline(val);
      }
    });
  }

}
